import { API } from '@/utils/api'
import { merge, pick } from 'lodash'

export default {
  login (context, user) {

    const uuid = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c, r) => (c == 'x' ? (r = Math.random() * 16 | 0) : (r & 0x3 | 0x8)).toString(16))

    let resp = { data: { token: uuid() } }

    const token = resp.data.token
    localStorage.setItem('user-token', token) // store the token in localstorage
    localStorage.setItem('user', JSON.stringify(user))

    // resolve(resp)

    return API.call('/login.json', merge(pick(user, [ 'login', 'password', 'twofa' ]), { token })).then(resp => {
      localStorage.setItem('user-token', token) // store the token in localstorage

      context.commit('app/setSocketUrl', resp, { root: true })
      context.commit('app/setSocketSid', resp, { root: true })
      context.commit('account/setDefaultCommentsTab', { role: resp.user.role }, { root: true })
      context.commit('successLogin', resp)
      context.dispatch('heartbeat')

      return resp
    }).catch(err => {
      localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible

      context.commit('failLogin')
      throw err
    })

  },

  checkSession (context) {
    let token = localStorage.getItem('user-token')
    return API.call('/session.json', { token }).then(resp => {
      context.commit('app/setTitle', resp, { root: true })
      context.commit('app/setSocketUrl', resp, { root: true })
      context.commit('app/setSocketSid', resp, { root: true })
      if (resp.token === token) {
        context.commit('account/setDefaultCommentsTab', { role: resp.user.role }, { root: true })
        context.commit('successLogin', resp)
        context.dispatch('heartbeat')
      } else {
        localStorage.removeItem('user-token')
        context.commit('failLogin')
      }
      return resp
    }).catch(err => {
      localStorage.removeItem('user-token')
      context.commit('failLogin')
      context.commit('setHeartbeatTimeoutHandle')
      return {
        error: err
      }
    })
  },

  setAction (context) {
    let token = localStorage.getItem('user-token')
    return API.call('/action.json', { token }).then(resp => {
      return resp
    })
  },

  heartbeat(context) {
    if (context.state.heartbeatTimeoutHandle) {
      return
    }

    const heartbeatTimeoutHandle = setTimeout(() => {
      API.call('/heartbeat.json').then(() => {
        context.commit('setHeartbeatTimeoutHandle')
        context.dispatch('heartbeat')
      })
    }, 1000 * 60)
    context.commit('setHeartbeatTimeoutHandle', heartbeatTimeoutHandle)
  },

  logout (context) {
    context.commit('login')
  },

  recentViewLoad (context) {
    return API.call('/recent_views.json').then(resp => {
      context.commit('recentViewLoad', resp.data || [])
    })
  },

}
